const step_schema_gap = [
    //Vehicle
    {
        key: 'vrm',
    },
    {
        key: 'make',
        required: true,
        skip_question: true,

    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        required: true,
        skip_question: true,
    },
    {
        key: 'body_type',
    },
    {
        key: 'value',
    },
    {
        key: 'owner_since',
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    {
        key: 'date_of_birth',
    },
    {
        key: 'postcode',
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'employment_status',
    },
    //policy
    {
        key: 'cover_date',
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'},
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_gap;
